import { CoverageTypeEnum } from "@platform/types";

/**
 * State Disability & Leaves is a pseudo-coverage that only the
 * document library renders (it is not a real BTX coverage). Keeping it out of
 * the shared CoverageTypeEnum means exhaustive maps and switches elsewhere in
 * the codebase don't have to account for it. This extended type adds it back
 * for the document library's own use.
 */
export const DocumentLibraryCoverageType = {
  ...CoverageTypeEnum,
  STATE_DISABILITY_AND_LEAVES: "stateDisabilityAndLeaves",
} as const;

export type DocumentLibraryCoverageType =
  (typeof DocumentLibraryCoverageType)[keyof typeof DocumentLibraryCoverageType];

const DOCUMENT_LIBRARY_COVERAGE_TYPE_VALUES = new Set<string>(
  Object.values(DocumentLibraryCoverageType),
);

export function isDocumentLibraryCoverageType(
  value: string,
): value is DocumentLibraryCoverageType {
  return DOCUMENT_LIBRARY_COVERAGE_TYPE_VALUES.has(value);
}
